import { toN } from "./safe-number.js";
//#region src/lib/shimmer.ts
function toBase64(str) {
	return typeof window === "undefined" ? Buffer.from(str, "utf-8").toString("base64") : window.btoa(str);
}
function fromBase64(str) {
	typeof window === "undefined" ? Buffer.from(str, "base64").toString("utf-8") : window.atob(str);
}
function shimmerScaffold({ w, h }) {
	return `<svg width="${toN(w)}" height="${toN(h)}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#333" offset="20%" />
      <stop stop-color="#222" offset="50%" />
      <stop stop-color="#333" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${toN(w)}" height="${toN(h)}" fill="#333" />
  <rect id="r" width="${toN(w)}" height="${toN(h)}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${toN(w)}" to="${toN(w)}" dur="1s" repeatCount="indefinite"  />
</svg>`;
}
/**
* use in the "blurDataUrl" property of the Nextjs Image component and set the "placeholder" property to "blur"
*/
function shimmer([w, h]) {
	return `data:image/svg+xml;base64,${toBase64(shimmerScaffold({
		w,
		h
	}))}`;
}
//#endregion
export { fromBase64, shimmer, shimmerScaffold, toBase64 };
